import type { ReportSpec } from '../models/report.types'

import { buildReportQuery } from './reportQueryString'

export type ReportRequestKind = 'schedule' | 'composition' | 'precalculated' | 'account'

export interface ReportRequestContext {
  accountId: number
  workspaceId: number | string
  workspaceIds?: readonly (number | string)[]
  scheduleId?: number | string | null
  productPrecalculated?: boolean
  exportRequest?: boolean
}

export interface ResolvedReportRequest {
  kind: ReportRequestKind
  url: string
  query: string
}

/** Pure controller endpoint selection, ported from reportStore.getReportData (contract 08 section 6). */
export function resolveReportRequest(
  spec: ReportSpec,
  context: ReportRequestContext,
): ResolvedReportRequest {
  const workspaceIds = context.workspaceIds ?? []
  const query = buildReportQuery(spec, {
    workspaceIds,
    ...(context.exportRequest === undefined ? {} : { exportRequest: context.exportRequest }),
  })

  if (context.productPrecalculated && spec.partition_name === 'metrics_product') {
    const workspaceId = workspaceIds[0] ?? context.workspaceId
    return {
      kind: 'precalculated',
      url: `/accounts/${context.accountId}/workspaces/${workspaceId}/controller_precalculated/?`,
      query,
    }
  }
  if (spec.config_id !== undefined) {
    return {
      kind: 'composition',
      url: `/accounts/${context.accountId}/workspaces/${context.workspaceId}/controller_composition/?`,
      query,
    }
  }
  if (workspaceIds.length > 0) {
    return {
      kind: 'account',
      url: `/accounts/${context.accountId}/v1/controller?`,
      query,
    }
  }
  if (context.scheduleId === undefined || context.scheduleId === null) {
    throw new TypeError(`Missing schedule for report ${String(spec.report_id ?? 'unknown')}`)
  }
  return {
    kind: 'schedule',
    url: `/accounts/${context.accountId}/workspaces/${context.workspaceId}/schedules/${context.scheduleId}/v1/controller?`,
    query,
  }
}
